;(function ($) {
  "use strict"

  const isLargeDown = window.matchMedia("(max-width: 1000px)")
  const isLargeUp = window.matchMedia("(min-width: 1000px)")

  $(document).ready(function () {
    const $header = $(".app-header")
    const $mobileMenuToggle = $(".mobile-menu-toggle")
    const $navigation = $(".primary-navigation")
    const $subMenuTitle = $(".sub-menu-title")
    const $body = $("body")

    function resetNavigation() {
      $mobileMenuToggle.removeClass("is-visible")
      $subMenuTitle.removeClass("is-open")
      $subMenuTitle.next().fadeOut(200)
      $header.removeClass("is-visible")
      $body.removeClass("no-scroll")
      //TODO: Fix this bug. Closes keyboard on Samsung Galaxy
      // $mobileMenuToggle.focus()
    }

    function toggleMenu() {
      $mobileMenuToggle.toggleClass("is-visible")
      $navigation.fadeToggle(200)
      $header.toggleClass("is-visible")
      $body.toggleClass("no-scroll")

      if (isLargeDown.matches) {
        const isExpanded = $mobileMenuToggle.hasClass("is-visible")

        if (isExpanded) {
          $navigation.createTabTrap({
            closeElement: $mobileMenuToggle,
          })
        }
      }
    }

    function toggleSubMenu() {
      $(this).toggleClass("is-open").next().fadeToggle(200)

      const isExpanded = $(this).hasClass("is-open")

      $header.addClass("is-visible")
      $subMenuTitle
        .not(this)
        .removeClass("is-open")
        .next()
        .fadeOut(200)
        .attr("aria-hidden", "true")

      $(this).attr("aria-expanded", isExpanded)
      $(this).next().attr("aria-hidden", !isExpanded)

      if (isExpanded) {
        $(this)
          .next()
          .createTabTrap({
            closeElement: $(this),
          })
      } else {
        $(this).focus()
      }
    }

    function handleEscapeKey(e) {
      if (e.key === "Escape") {
        resetNavigation()
        if (isLargeDown.matches) {
          $navigation.fadeOut(200)
        }
      }
    }

    function handleResize() {
      if (isLargeDown.matches) {
        resetNavigation()
        $navigation.fadeOut(200)
      } else {
        $navigation.fadeIn(200)
      }
    }

    $mobileMenuToggle.on("click", toggleMenu)
    $subMenuTitle.on("click", toggleSubMenu)
    $(document).on("keydown", handleEscapeKey)
    $(window).on("resize", handleResize)
    $body.on("click", function (e) {
      if (
        !$(e.target).closest($header).length &&
        $header.hasClass("is-visible")
      ) {
        resetNavigation()
      }
    })
  })
})(jQuery)
